<template>
    <button
        class="ui-btn ui-btn--theme-circle"
        :class="{'ui-btn--active': isActive, 'ui-btn--have-section': activeSection && showProgress}"
        @click="$emit('click')"
    >
        <span class="ui-btn__item ui-btn--item-one"></span>
        <span class="ui-btn__item ui-btn--item-two"></span>
        <span class="ui-btn__item ui-btn--item-three"></span>
        <transition name="only-fade">
            <VueCircle
                ref="circle"
                :progress="progress"
                :size="size"
                :style="styles"
                class="ui-btn__progress"
                :show-percent="false"
                :reverse="false"
                :fill="fill"
                empty-fill="rgba(0, 0, 0, 0)"
                :animation="false"
                :start-angle="1.5 * Math.PI"
                insert-mode="append"
                :thickness="2"
                v-if="activeSection && showProgress"
            >
                {{ sectionLabel }}
            </VueCircle>
        </transition>
    </button>
</template>

<script>
import VueCircle from 'vue2-circle-progress'

const labels = [
    '', '0-3', '3-6', '6-12', '12-15', '15-17'
]

const colors = [
    '#FAB903', '#8DD2D9', '#FAB903', '#66BD5A', '#8d91e6', '#328ec6'
]

export default {
    components: {
        VueCircle
    },
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        progress: {
            type: Number,
            default: 0
        },
        activeSection: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            size: document.documentElement.clientWidth > 959 ? 47 : 34
        }
    },
    computed: {
        sectionLabel () {
            return labels[this.activeSection]
        },
        styles () {
            return {
                color: colors[this.activeSection]
            }
        },
        fill () {
            return {
                color:
                    colors[this.activeSection]
            }
        }
    },
    watch: {
        activeSection (sectionIndex) {
            this.$nextTick(() => {
                if (this.$refs.circle) this.$refs.circle.updateFill(colors[sectionIndex])
            })
        },
        progress (p) {
            if (this.$refs.circle) this.$refs.circle.updateProgress(p);
        }
    }
}
</script>

<style scoped lang="stylus">
    .ui-btn {
        padding 0
        transition-duration 0.3s
        outline none
        width 3.4rem
        height 3.4rem
        background-color: #fff
        border 0.2rem solid $color-yellow
        border-radius 50%
        display flex
        position relative
        align-items center
        justify-content center
        flex-direction column

        +layout-sm-and-up() {
            width 4.7rem
            height 4.7rem
        }

        +layout-md-and-up() {
            cursor pointer
        }

        &__item {
            width: 1.8rem
            height: 0.2rem
            background-color $color-yellow
            margin-top: 0.2rem
            margin-bottom: 0.2rem
            border-radius 1rem

            +layout-sm-and-up() {
                width: 2.5rem
            }
        }

        &--active {
            align-items: center
            position: relative
            transform rotate(45deg)
            & ^[0]__item{
                margin 0
                position: absolute
                top 50%
                left 50%
                transition-duration 0.3s
            }

            & ^[0]--item-one {
                transform translate(-50%, -50%) rotate(90deg)
                transform-origin center center
            }
            & ^[0]--item-two {
                display: none
            }
            & ^[0]--item-three {
                transform translate(-50%, -50%)
            }
        }

        &__progress.circle {
            display block
            position absolute
            top -.2rem
            left -.2rem
            right -.2rem
            bottom -.2rem
            font-weight 700
            background #fff
            font-size 1.1rem
            border-radius 50%
            text-align center
            letter-spacing 0.15px
            line-height 3rem
            transition color .15s linear

            +layout-sm-and-up() {
                font-size 1.4rem
                line-height 4.3rem
            }
        }
    }

    .only-fade-leave-active,
    .only-fade-enter-active {
        transition opacity 0.3s ease .3s
    }

    .only-fade-enter,
    .only-fade-leave-to {
        opacity 0
    }
</style>
